import { useSmartLinkContext } from '@atlaskit/link-provider';
export var useSmartLinkConfig = function useSmartLinkConfig() {
  var context = useSmartLinkContext();
  if (context) {
    return context.config;
  }
  return undefined;
};